(() => {
function $f892de8327dc9e0f$export$2952830753ee3df9() {
    const tabLinkList = document.querySelectorAll(".heatbox-tab-nav-item a");
    tabLinkList.forEach(function(tabLink) {
        tabLink.addEventListener("click", function(e) {
            const href = tabLink.href;
            const hrefValue = href ? href.split("#")[1] : "";
            $f892de8327dc9e0f$var$switchTab(hrefValue);
        });
    });
    window.addEventListener("load", function(_e) {
        let hash = window.location.hash;
        hash = hash ? hash : "#smtp";
        const hashValue = hash.replace("#", "");
        $f892de8327dc9e0f$var$switchTab(hashValue);
    });
}
function $f892de8327dc9e0f$var$switchTab(tab) {
    const tabLinkList = document.querySelectorAll(".heatbox-tab-nav-item a");
    tabLinkList.forEach(function(tabLink) {
        const parentEl = tabLink.parentElement;
        if (!parentEl) return;
        const href = tabLink.href;
        const hrefValue = href ? href.split("#")[1] : "";
        if (hrefValue === tab) parentEl.classList.add("active");
        else parentEl.classList.remove("active");
    });
    const tabContentList = document.querySelectorAll("[data-show-when-tab]");
    tabContentList.forEach(function(tabContent) {
        const rawTabValue = tabContent.dataset.showWhenTab;
        const tabValues = rawTabValue ? rawTabValue.split(",") : [];
        const tabValuesTrimmed = tabValues.map((value)=>value.trim());
        if (tabValuesTrimmed.includes(tab)) tabContent.style.display = "block";
        else tabContent.style.display = "none";
    });
    $f892de8327dc9e0f$var$setRefererValue(tab);
}
/**
 * Set referer value for the tabs navigation of settings page.
 * This is being used to preserve the active tab after saving the settings page.
 *
 * @param {string} hashValue The hash value.
 */ function $f892de8327dc9e0f$var$setRefererValue(hashValue) {
    const refererField = document.querySelector('[name="_wp_http_referer"]');
    if (refererField) {
        if (refererField.value.includes("#")) {
            const urlSplits = refererField.value.split("#");
            const url = urlSplits[0];
            refererField.value = url + "#" + hashValue;
        } else refererField.value = refererField.value + "#" + hashValue;
    }
    const resetLink = document.querySelector('.weed-reset-button');
    if (resetLink) {
        if (resetLink.href.includes("#")) {
            const urlSplits = resetLink.href.split("#");
            const url = urlSplits[0];
            resetLink.href = url + "#" + hashValue;
        } else resetLink.href = resetLink.href + "#" + hashValue;
    }
}


async function $0670dfea8ff007c0$export$2cdf1b96a9f86d16(text) {
    try {
        await navigator.clipboard.writeText(text);
    } catch (err) {
        // console.error("Unable to copy text to clipboard:", err);
        await $0670dfea8ff007c0$export$89296fcf373e3bb8(text);
    }
}
async function $0670dfea8ff007c0$export$89296fcf373e3bb8(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = "-3px";
    textArea.style.left = "-3px";
    textArea.style.width = "1px";
    textArea.style.height = "1px";
    textArea.style.background = "transparent";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand("copy");
    } catch (err) {
        console.error("Unable to copy text to clipboard:", err);
    }
    document.body.removeChild(textArea);
}
function $0670dfea8ff007c0$export$fea330ef6103f535(button) {
    if (!button) return;
    button.classList.add("is-loading");
}
function $0670dfea8ff007c0$export$4dabcd056c1d895c(button) {
    if (!button) return;
    button.classList.remove("is-loading");
}
function $0670dfea8ff007c0$export$b25305d7fdb340d7(props) {
    const type = props.type ? props.type : 'success';
    const msg = props.msg ? props.msg : '';
    props.el.classList.add("is-" + type);
    props.el.innerHTML = msg;
    props.el.classList.remove("is-hidden");
}
function $0670dfea8ff007c0$export$3bddf9505d6a7871(el) {
    el.classList.add("is-hidden");
    el.classList.remove("is-success");
    el.classList.remove("is-error");
    el.classList.remove("is-failed");
    el.classList.remove("is-warning");
    el.classList.remove("is-info");
    el.innerHTML = '';
}


function $b3f9777c5cd7a583$export$68e1a451ce9a75b() {
    init();
    function init() {
        const metabox = document.querySelector(".tags-heatbox");
        if (!metabox) return;
        const tags = metabox.querySelectorAll("code");
        if (!tags.length) return;
        tags.forEach((tag)=>{
            tag.addEventListener("click", handleTagClick);
        });
    }
    async function handleTagClick(e) {
        const tag = e.target;
        if (!tag) return;
        const value = tag.innerText;
        if (!value) return;
        // Copy value to clipboard.
        await (0, $0670dfea8ff007c0$export$2cdf1b96a9f86d16)(value);
        const notice = document.querySelector(".tags-heatbox .action-status");
        if (!notice) return;
        notice.classList.add("is-shown");
        setTimeout(()=>{
            notice.classList.remove("is-shown");
        }, 1500);
    }
}



function $b7fa599c6ece7e06$export$f5ae4047b516e509() {
    let isRequesting = false;
    init();
    function init() {
        // @ts-ignore
        jQuery(document).on("click", ".weed-test-email-button", sendTestEmail);
    }
    /**
	 * Send test email via ajax request.
	 */ function sendTestEmail(e) {
        e.preventDefault();
        // @ts-ignore
        const button = this;
        if (!button) return;
        const allNoticeEls = document.querySelectorAll(".weed-submission-notice");
        allNoticeEls.forEach(function(el) {
            (0, $0670dfea8ff007c0$export$3bddf9505d6a7871)(el);
        });
        const parentEl = button.parentElement;
        const noticeEl = parentEl ? parentEl.querySelector(".weed-submission-notice") : null;
        if (isRequesting) return;
        isRequesting = true;
        (0, $0670dfea8ff007c0$export$fea330ef6103f535)(button);
        const data = {};
        data.email_type = button.dataset.emailType;
        data.action = "weed_test_emails";
        switch(data.email_type){
            case "admin_new_user_notif_email":
                data.nonce = weedSettings.nonces.adminWelcomeEmail;
                break;
            case "user_welcome_email":
                data.nonce = weedSettings.nonces.userWelcomeEmail;
                break;
            case "reset_password_email":
                data.nonce = weedSettings.nonces.resetPasswordEmail;
                break;
            case "test_smtp_email":
                data.nonce = weedSettings.nonces.testSmtpEmail;
                const toEmailField = document.querySelector("#weed_settings--test_smtp_recipient_email");
                data.to_email = toEmailField ? toEmailField.value : "";
                break;
            case "test_mailjet_api_email":
                data.nonce = weedSettings.nonces.testMailjetApiEmail;
                const mailjetToEmailField = document.querySelector("#weed_settings--test_mailjet_api_recipient_email");
                data.to_email = mailjetToEmailField ? mailjetToEmailField.value : "";
                break;
            case "test_mailjet_api_with_attachment":
                data.nonce = weedSettings.nonces.testMailjetApiEmailWithAttachment;
                const mailjetAttachmentToEmailField = document.querySelector("#weed_settings--test_mailjet_api_recipient_email");
                data.to_email = mailjetAttachmentToEmailField ? mailjetAttachmentToEmailField.value : "";
                break;
        }
        if (noticeEl) (0, $0670dfea8ff007c0$export$3bddf9505d6a7871)(noticeEl);
        jQuery.ajax({
            url: ajaxurl,
            type: "post",
            dataType: "json",
            data: data
        }).always(function(r) {
            isRequesting = false;
            (0, $0670dfea8ff007c0$export$4dabcd056c1d895c)(button);
            if (noticeEl) (0, $0670dfea8ff007c0$export$b25305d7fdb340d7)({
                el: noticeEl,
                type: r.success ? "success" : "error",
                msg: r.data
            });
        });
    }
}


function $1ed547093d80174e$export$ba3937e898758160() {
    const showWhenCheckedEls = document.querySelectorAll("[data-show-when-checked]");
    const fields = [];
    const fieldNames = [];
    const conditionalEls = [];
    showWhenCheckedEls.forEach(function(showWhenCheckedEl) {
        const rawFieldSelector = showWhenCheckedEl.dataset.showWhenChecked;
        const fieldName = rawFieldSelector ? rawFieldSelector : "";
        if (!fieldName) return;
        const field = document.querySelector('[name="' + fieldName + '"]');
        if (!field) return;
        if (!fieldNames.includes(fieldName)) {
            fieldNames.push(fieldName);
            fields.push(field);
        }
        conditionalEls.push(showWhenCheckedEl);
        if (field.checked) showWhenCheckedEl.style.display = "block";
        else showWhenCheckedEl.style.display = "none";
    });
    fields.forEach(function(field) {
        field.addEventListener("change", function(e) {
            if (field.checked) conditionalEls.forEach(function(conditionalEl) {
                const rawFieldSelector = conditionalEl.dataset.showWhenChecked;
                const fieldName = rawFieldSelector ? rawFieldSelector : "";
                if (!fieldName) return;
                if (fieldName === field.name) conditionalEl.style.display = "block";
            });
            else conditionalEls.forEach(function(conditionalEl) {
                const rawFieldSelector = conditionalEl.dataset.showWhenChecked;
                const fieldName = rawFieldSelector ? rawFieldSelector : "";
                if (!fieldName) return;
                if (fieldName === field.name) conditionalEl.style.display = "none";
            });
        });
    });
    // Handle mailer type radio button conditional fields
    const mailerTypeConditionalEls = document.querySelectorAll("[data-show-when-mailer-type]");
    const mailerTypeRadios = document.querySelectorAll('[name="weed_settings[mailer_type]"]');
    function updateMailerTypeFields() {
        const selectedMailerType = document.querySelector('[name="weed_settings[mailer_type]"]:checked')?.value || "smtp";
        mailerTypeConditionalEls.forEach(function(conditionalEl) {
            const showWhen = conditionalEl.dataset.showWhenMailerType;
            if (!showWhen) return;
            if (showWhen === selectedMailerType) conditionalEl.style.display = "block";
            else conditionalEl.style.display = "none";
        });
    }
    // Initialize field visibility on page load
    updateMailerTypeFields();
    // Update field visibility when mailer type changes
    mailerTypeRadios.forEach(function(radio) {
        radio.addEventListener("change", updateMailerTypeFields);
    });
    const smtpEncryptionFields = document.querySelectorAll('[name="weed_settings[smtp_encryption]"]');
    smtpEncryptionFields.forEach(function(smtpEncryptionField) {
        smtpEncryptionField.addEventListener("change", handleSmtpEncryptionFieldChange);
    });
    function handleSmtpEncryptionFieldChange(e) {
        const value = e.target.value;
        const smtpPortField = document.querySelector('[name="weed_settings[smtp_port]"]');
        if (!smtpPortField) return;
        if (value === "ssl") smtpPortField.value = "465";
        else if (value === "tls") smtpPortField.value = "587";
        else smtpPortField.value = "25";
    }
}


function $3fb511a7894c3583$export$2e2bcd8739ae039() {
    // @ts-ignore
    jQuery(document).on("click", ".weed-reset-settings-button", $3fb511a7894c3583$var$resetSettings);
}
function $3fb511a7894c3583$var$resetSettings(e) {
    if (!confirm(weedSettings.warningMessages.resetSettings)) e.preventDefault();
}


(0, $3fb511a7894c3583$export$2e2bcd8739ae039)();
(0, $f892de8327dc9e0f$export$2952830753ee3df9)();
(0, $b3f9777c5cd7a583$export$68e1a451ce9a75b)();
(0, $1ed547093d80174e$export$ba3937e898758160)();
(0, $b7fa599c6ece7e06$export$f5ae4047b516e509)();

})();
//# sourceMappingURL=settings.js.map
